import Button from '@components/Button'
import { Col, Row } from 'react-styled-flexboxgrid'
import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.brandSupporting01Contrast};
  padding: ${({ theme }) => theme.space.sm} ${({ theme }) => theme.space.md};
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  border: 1px solid ${({ theme }) => theme.colors.brandPrimary};
  box-shadow: 0 2px 13px 0 rgba(0, 0, 0, 0.17);
  border-radius: ${({ theme }) => theme.radius.lg};
`

export const NextLvlCol = styled(Col)`
  padding: 0;
  display: flex;
  flex-wrap: wrap;
`

export const StyledButton = styled(Button)`
  padding: ${({ theme }) => theme.space.xs} ${({ theme }) => theme.space.sm};
`

export const H1 = styled.div`
  font-size: ${({ theme }) => theme.fontSize.xs};
  line-height: ${({ theme }) => theme.lineHeight.md};
  color: ${({ theme }) => theme.colors.brandPrimary};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`
export const H2 = styled.div`
  font-size: ${({ theme }) => theme.fontSize.xxs};
`

export const ButtonCol = styled(Col)`
  padding: 0 0 0 ${({ theme }) => theme.space.md};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
`

// Dashboard styling
export const Container = styled.div<{ isStacked?: boolean }>`
  padding: ${({ theme }) => theme.space.xs};
  position: relative;
  text-align: center;
  width: 100%;
  padding-bottom: ${({ theme }) => theme.space.sm};
  background-color: ${({ theme }) => theme.palette.white};
  border-radius: ${({ theme }) => theme.radius.lg};
  border: 1px solid ${({ theme }) => theme.colors.brandPrimary};
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.4);

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: ${({ theme }) => theme.space.md};
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: block;
    margin-bottom: 0px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    display: block;
  }
`

export const Title = styled.div`
  display: inline-flex;
  line-height: 22px;
  letter-spacing: 0.56;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  font-size: ${({ theme }) => theme.fontSize.xs};
  text-align: center;

  svg {
    font-size: 20px;
    color: ${({ theme }) => theme.palette.blue100};
  }

  > span:last-child {
    top: ${({ theme }) => theme.space.xxs};
    left: ${({ theme }) => theme.space.xxs};
    position: relative;
  }

  color: ${({ theme }) => theme.palette.blue100};
`

export const SubTitle = styled.div`
  padding-right: 26px;
  display: block;
  padding-left: 15px;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSize.xxs};
  margin-top: ${({ theme }) => theme.space.xs};

  & > span {
    color: ${({ theme }) => theme.palette.blue100};
  }
`

export const TitleWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.space.xs};
`
